import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

export function useIsSizeRecommendationEnabled(): boolean {
  const { data: shop } = useCurrentShopSuspense();
  return !!shop?.plan.sizeRecommendation;
}
